import React, {Component} from 'react'
import {connect} from "react-redux";
import "./Pagination.scss"

class Pagination_ extends Component {

  constructor(props) {
    super(props)
  }

  render() {
    const { nav, pageForward, pageBackward, pageToFirst, pageToLast } = this.props
    const count = nav ? nav.count : 0
    const pageSize = nav ? nav.page_size : 50
    const pageNumber = nav ? nav.page_number : 1

    const maxPage = nav ? nav.max_page : 1
    const lastPage = nav && !nav.has_next
    const firstItemIndex = (pageNumber - 1) * pageSize + 1
    const lastItemIndex = lastPage ? count : firstItemIndex + (pageSize - 1)
    const message = count === 0 ? "0 items" : `${firstItemIndex} - ${lastItemIndex} of ${count}`

    return (
      <div className="Pagination__row">
        {nav && nav.has_prev && <div className="Pagination__horizontal_margin__page_left_double" onClick={pageToFirst} />}
        {nav && nav.has_prev && <div className="Pagination__horizontal_margin__page_left" onClick={pageBackward} />}
        <div className="Pagination__message">{message}</div>
        {nav && nav.has_next && <div className="Pagination__horizontal_margin__page_right" onClick={pageForward} />}
        {nav && nav.has_next && maxPage && <div className="Pagination__horizontal_margin__page_right_double" onClick={pageToLast} />}
      </div>
    )

  }


}

const withRedux = connect()
export const Pagination = withRedux(Pagination_)
export { Pagination as _Pagination }
